
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { UpdateMoodProps } from '../../typings/mood'
import { updateMemberMood } from '../../services/moodService'
import { useHistory } from 'react-router';
import { setUserData } from '../../redux/member';
import { MoodProps } from '../../typings/mood';
import { HOMEPAGE } from '../../navigation/Constants';


const MoodInfo = (props: any) => {

    const { mood } = props;
    const [moodInfo, setMoodInfo] = useState<string>("");
    const member = useSelector((state: RootState) => state.member);
    let history = useHistory();
    const dispatch = useDispatch();

    const onClickBack = () => {
        props.back();
    }

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const updateMood: UpdateMoodProps = {
            moodId: mood.moodId,
            memberCode: member.memberCode,
            moodInfo: moodInfo
        }
        await updateMemberMood(updateMood);
        updateMemberProps();

        //history.replace(HOMEPAGE);
        history.goBack();

    };

    const updateMemberProps = () => {
        member.moodImage = mood.moodImage;
        member.moodText = mood.moodText;
        member.profileSentence = moodInfo;
        dispatch(setUserData(member));
    };


    return (

        <div className="content_sec red wf-section">
            <div className="mood_info_content">
                <a onClick={onClickBack} href="#" className="mood_close w-inline-block">
                    <img src="/assets/images/ic_back.svg" loading="lazy" alt="" />
                </a>
                <div className="mood_info_pict">
                    <img src={mood.moodImage} loading="lazy" alt="" />
                </div>
                <div className="mood_info_txt">&nbsp;</div>
                <h2 className="signup_title mood"> אשמח ל{mood.moodText}</h2>
                <div className="mood_form_block w-form">
                    <form onSubmit={handleSubmit}>
                        <textarea
                            placeholder="ואפשר להוסיף גם כמה מילים, כמו איפה היית רוצה להיפגש או עם מי במיוחד"
                            maxLength={100}
                            value={moodInfo} onChange={e => setMoodInfo(e.target.value)}
                            className="txt_field mood_area w-input"
                            style={{ textAlign: 'right' }}
                        />
                        <input autoComplete="off"
                            type="submit"
                            value="הוספה לפרופיל"
                            data-wait
                            className="button_full mood w-button"
                        />
                    </form>
                </div>
            </div>
        </div>
    )

}

export default MoodInfo;

